import UniversalRouter from 'universal-router';
import _ from 'lodash';
import routes from './routes';

export default new UniversalRouter(routes, {
  resolveRoute(context, params) {
    const { user } = context.store.getState();
    if (context.route.protected && !user) {
      const queryString = context.search ? context.search : '';
      return { redirect: `/login${queryString}`, from: context.pathname };
    }
    if (_.isArray(context.route.providerRestricted) && !context.route.providerRestricted
      .includes(user.software_provider)) {
      return undefined;
    }
    if (typeof context.route.load === 'function') {
      return context.route
        .load(context)
        .then(action => action.default(context, params));
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return undefined;
  },
});
